import { Component } from '@angular/core';

interface Group {
    name: string;
    entries: Item[];
    isOpen: boolean;
}

interface Item {
    isChecked: boolean;
    name: string;
}

@Component({
    selector: 'admin-debug',
    templateUrl: './admin-debug.component.html',
    styleUrls: ['./admin-debug.component.scss'],
})
export class AdminDebugComponent {
    constructor() {}

    showLoading: boolean = false;

    data: Group[] = [
        {
            name: 'First',
            isOpen: false,
            entries: [
                {
                    name: 'Fred',
                    isChecked: false,
                },
                {
                    name: 'Jim',
                    isChecked: false,
                },
                {
                    name: 'Sheila',
                    isChecked: false,
                },
            ],
        },
        {
            name: 'Second',
            isOpen: false,
            entries: [
                {
                    name: 'John',
                    isChecked: false,
                },
                {
                    name: 'Paul',
                    isChecked: false,
                },
                {
                    name: 'George',
                    isChecked: false,
                },
            ],
        },
        {
            name: 'Third',
            isOpen: false,
            entries: [
                {
                    name: 'Curly',
                    isChecked: false,
                },
                {
                    name: 'Larry',
                    isChecked: false,
                },
                {
                    name: 'Moe',
                    isChecked: false,
                },
            ],
        },
    ];

    toggle(group: Group) {
        group.isOpen = !group.isOpen;
    }
}
